import { Card, CardBody, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Apps, Calendar, CalendarBasic } from "../../Constant";
import DragCalendar from "./DragCalendar";

const CalenderContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={CalendarBasic} parent={Apps} title={Calendar} />
      <Container fluid className="calendar-basic">
        <Card>
          <CardBody>
            <Row>
              <DragCalendar />
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default CalenderContainer;
